<script>
  import TypeaheadInput from 'components/eHorizon/Typeahead/Input'
  import Item from 'components/eHorizon/Destination/OriginItem'

  export default {
    components: {
      item: Item
    },
    extends: TypeaheadInput
  }
</script>

<style
  lang="scss"
  rel="stylesheet/scss"
>
  @import '~assets/styles/common.scss';

  .e-horizon-orig-destin {
    background: white;
    width: 100%;
    border-radius: 3px;
    position: relative;
    height: 56px;
    border: 1px solid $grey-border-light;

    &.active {
      @include bp-tablet-only {
        z-index: 2;
      }
    }

    @include bp-mf-desktop {
      min-height: 48px;
      height: 56px;
    }

    &.destin {
      border-radius: 0 0 4px 4px;
      border-top: none;

      &.blue-border {
        border: 1px solid $blue-medium;
      }

      &.error {
        border: 1px solid $red-error;
        margin-bottom: 0;

        &:not(.active) {
          input {
            @include input-placeholder {
              color: rgba($red-placeholder, 0.5);
            }
          }
        }
      }

      @include bp-desktop-small() {
        width: 200px;
      }

      @include bp-mf-desktop {
        width: 50%;
        border-radius: 0 4px 4px 0;
        border-top: 1px solid $blue-border;
      }

      input[type='text'] {
        @include bp-mf-desktop {
          border-radius: 0;
        }
      }
    }

    &.origin {
      border-radius: 4px 4px 0 0;

      &.blue-border {
        border: 1px solid $blue-medium;
      }

      &.error {
        border: 1px solid $red-error;
        margin-bottom: 0;

        &:not(.active) {
          input {
            @include input-placeholder {
              color: rgba($red-placeholder, 0.5);
            }
          }
        }
      }

      @include bp-desktop-small {
        width: 200px;
      }

      @include bp-mf-desktop {
        border-radius: 4px 0 0 4px;
        width: 50%;
        border-right: initial;
        margin: 0;
      }

      input[type='text'] {
        @include bp-mf-desktop {
          border-radius: 4px 0 0 4px;
        }
      }
    }

    input[type='text'] {
      height: 56px;
      width: 244px;
      padding: 13px 10px 0;
      border: none;
      color: $grey-default;
      font-size: em(16);

      @include bp-mf-desktop {
        height: 56px;
        padding: 0;
      }
    }

    @include input-placeholder {
      color: $input-placeholder;
    }

    @include bp-mf-desktop {
      border-radius: 3px 0 0 3px;
    }

    &::selection {
      background-color: $green-base;
    }
  }
</style>
